export default {
      id: "i-main-advantages-04-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "img/sprite.svg#i-main-advantages-04",
      toString: function () {
        return this.url;
      }
    }